import { render, staticRenderFns } from "./ValoracionInicial.vue?vue&type=template&id=12c01725&"
import script from "./ValoracionInicial.vue?vue&type=script&lang=js&"
export * from "./ValoracionInicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports